/**
 * @desc 查询目录树
 */
import {
  HelpCatalogueEntity,
  HelpCatalogueTreeQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryHelpCatalogueTreeParameter = HelpCatalogueTreeQuery

const method = 'GET'
const url = '/content/operation/help/catalogue/tree'

export const queryHelpCatalogueTreeApi = (
  params?: QueryHelpCatalogueTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<HelpCatalogueEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryHelpCatalogueTreeApi.method = method
queryHelpCatalogueTreeApi.url = url
